/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useRef, useState } from "react";
import "react-quill/dist/quill.snow.css";

interface QuillEditorProps {
  value: string;
  onChange: (content: string) => void;
  placeholder?: string;
}

export const QuillEditor: React.FC<QuillEditorProps> = ({
  value,
  onChange,
  placeholder = "Start writing...",
}) => {
  const [ReactQuill, setReactQuill] = useState<any>(null);
  const editorRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // Dynamically import react-quill when the component mounts
    import("react-quill")
      .then((module) => {
        setReactQuill(() => module.default);
      })
      .catch((error) => {
        console.error("Error loading ReactQuill:", error);
      });
  }, []);

  // Ensure the placeholder is set correctly after the editor is instantiated
  useEffect(() => {
    if (
      ReactQuill &&
      (value === "" || value === "<p><br></p>") &&
      editorRef.current
    ) {
      const editor = editorRef.current.querySelector(
        ".ql-editor"
      ) as HTMLElement;
      if (editor) {
        editor.setAttribute("data-placeholder", `${placeholder}`);
      }
    }
    if (ReactQuill && editorRef.current) {
      const editor2 = editorRef.current.querySelector(
        ".ql-container.ql-snow"
      ) as HTMLElement;
      if (editor2) {
        editor2.style.border = "0px";
      }
    }
  }, [ReactQuill, value]);

  // Quill editor configuration
  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }], //{ font: [] }
      [{ list: "ordered" }, { list: "bullet" }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      // [{ color: [] }, { background: [] }],
      [{ align: [] }],
      // ["link", "image", "video"],
      ["clean"],
    ],
  };

  const formats = [
    "header",
    // "font",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "color",
    "background",
    "align",
    "link",
    // "image",
    // "video",
  ];

  // Render loading or return null until the Quill editor is loaded
  if (!ReactQuill) {
    return <div>Loading editor...</div>;
  }

  return (
    <div className="my-4" ref={editorRef}>
      <ReactQuill
        value={value}
        onChange={onChange}
        theme="snow"
        modules={modules}
        formats={formats}
        className=" shadow-md rounded-lg  min-h-[200px] "
      />
    </div>
  );
};
